import { setProjectsInCookies } from './../../app/cookies';
import { logoutTC } from './../Login/auth-reducer';
import { projectsAPINEW } from '../../api/projects-api';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProjectType } from "../../api/projects-api";
import { setAppStatusAC } from '../../app/app-reducer';
import { handleRequestResponseError } from '../../utils/errorUtils/handleServerNetworkError';

// thunks
export const fetchProjectsTC = createAsyncThunk('projects/fetchProjects', async (token: string, {dispatch, getState, rejectWithValue}) => {
  dispatch(setAppStatusAC({status: 'loading'}))
  projectsAPINEW.getProjects(token)
    .then((res) => {
      if(res.status === 200){
        dispatch(setProjectsAC({projects: res.data}))
        setProjectsInCookies(res.data)
      } else {
        console.log('RESPONSE 401', res.status, res.statusText)
      }
      dispatch(setAppStatusAC({status: 'succeeded'}))
    })
    .catch(error => {
      handleRequestResponseError(error, dispatch)
      return rejectWithValue
    })
})

const slice = createSlice({
  name: 'projects',
  initialState: [] as Array<ProjectType>,
  reducers: {
    setProjectsAC(state, action: PayloadAction<{ projects: Array<ProjectType> }>) {
      if(action.payload){
         state = action.payload.projects
      }
      return action.payload.projects
    },
  }
})

export const projectsReducer = slice.reducer
export const { setProjectsAC } = slice.actions
